export default "__VITE_ASSET__81a73450__"